// Set per app, so the apps sharing this library can be told apart in GA4.
let appName

const pushToDataLayer = eventData => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(
    appName ? { ...eventData, app_name: appName } : eventData
  )
}

export default {
  setAppName(name) {
    appName = name
  },
  sendEvent(
    {
      action: gaAction,
      category: gaCategory,
      label: gaLabel,
      value: gaValue,
      nonInteractionEvent,
      gtmEventData
    },
    { isExternalLink }
  ) {
    pushToDataLayer({
      event: "genericEvent",
      gaAction,
      gaCategory,
      gaLabel,
      gaValue,
      isExternalLink,
      nonInteractionEvent,
      gtmEventData
    })
  },
  sendCustomEvent(eventData) {
    pushToDataLayer(eventData)
  },
  sendGenericEvent(params) {
    const {
      eventName,
      eventCategory = "N/A",
      eventAction = "N/A",
      entityName = "N/A",
      entityType = "N/A",
      entitySubtype = "N/A",
      entityVariant = "N/A",
      statusType = "N/A",
      value = "N/A"
    } = params

    pushToDataLayer({
      event: "genericEvent",
      event_name: eventName,
      event_category: eventCategory,
      event_action: eventAction,
      entity_name: entityName,
      entity_type: entityType,
      entity_subtype: entitySubtype,
      entity_variant: entityVariant,
      status_type: statusType,
      value
    })
  }
}
